import { useEffect, useState } from "react";
import { QueueTransport } from "src/app/transports/queues";
import { IQueueTotal } from "src/app/types/queue";

const useGetQueuesSize = (params?: object, inicialRequest = true) => {
    const [queueSize, setQueueSize] = useState<IQueueTotal>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const fetch = () => {
        setLoading(true);
        QueueTransport.getQueuesSize()
            .then((res) => setQueueSize(res))
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };
    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        if (inicialRequest) fetch();
    }, []);

    return { queueSize, refresh, loading, error };
};

export default useGetQueuesSize;
